import React, { useState, useContext, useEffect, useRef } from "react";
import "./MainSidebar.css";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import * as links from "../../../../utils/links";
import brandMark from "../../../../assets/images/brand_mark.png";
import AvatarCropper from "./AvatarCropper";
import { loadAvatar, saveAvatar, removeAvatar } from "../../../../utils/avatar";

const Sidebar = (props) => {
  const [isOpen, setIsOpen] = useState<any>(false);
  const location = useLocation();
  const { setDataUser, loading, authInfo, setNotiMessage } = useContext<any>(AuthContext);
  let navigate = useNavigate();
  const { dataUser } = authInfo;

  const fileInputRef = useRef<any>(null);
  const [avatar, setAvatar] = useState<any>(null);
  const [cropSrc, setCropSrc] = useState<any>(null);

  useEffect(() => {
    if (loading || !dataUser) return;
    const stored = loadAvatar(dataUser);
    if (stored) setAvatar(stored);
  }, [loading, dataUser]);

  const handleAvatarChange = (event) => {
    const file = event.target?.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      setCropSrc(reader.result as string);
    };
    reader.readAsDataURL(file);
    event.target.value = "";
  };

  const handleCropConfirm = (dataUrl: string) => {
    setAvatar(dataUrl);
    const ok = saveAvatar(dataUser, dataUrl);
    if (!ok) {
      setNotiMessage?.({
        type: "error",
        message:
          "Não foi possível salvar a foto neste dispositivo (armazenamento cheio).",
      });
    }
    setCropSrc(null);
  };

  const handleRemoveAvatar = () => {
    removeAvatar(dataUser);
    setAvatar(null);
  };


  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };


  useEffect(() => {
    console.log(authInfo)
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest(".sidebar")) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="sidebar-shell">
      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        <button
          className={`toggle ${isOpen ? "open" : ""}`}
          type="button"
          onClick={toggleOpen}
        >
          <i className="bi bi-chevron-right"></i>
        </button>
        <div className="inner">
          <div className="header">
            <button
              type="button"
              className="brand-mark-btn"
              onClick={toggleOpen}
              title="Menu"
            >
              <img src={brandMark} alt="Prax Pay" className="brand-mark" />
            </button>

            <h1 className={`header-title ${isOpen ? "open" : ""}`}>Prax Pay</h1>
          </div>

          <div className="user-card">
            <button
              type="button"
              className="user-avatar-btn"
              title="Adicionar foto do álbum"
              onClick={(e) => {
                e.stopPropagation();
                fileInputRef.current?.click();
              }}
            >
              {avatar ? (
                <img src={avatar} alt="Foto de perfil" className="user-photo" />
              ) : (
                <i className="bi bi-person-circle"></i>
              )}
              <span className="user-avatar-edit">
                <i className="bi bi-camera-fill"></i>
              </span>
            </button>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleAvatarChange}
            />
            <span className={`user-name ${isOpen ? "open" : ""}`}>
              {dataUser?.name}
            </span>
            {avatar && isOpen ? (
              <button
                type="button"
                className="user-avatar-remove"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveAvatar();
                }}
              >
                Remover foto
              </button>
            ) : null}
          </div>

          <AvatarCropper
            open={!!cropSrc}
            src={cropSrc}
            onCancel={() => setCropSrc(null)}
            onConfirm={handleCropConfirm}
          />


          <nav className="menu" onClick={() => setIsOpen(false)}>
            {dataUser?.key === "CLIENT" ? (
              <button
                className={
                  location.pathname === links.DASHBOARD_FORNECEDOR
                    ? "active"
                    : ""
                }
                type="button"
                onClick={() => {
                  navigate(links.DASHBOARD_FORNECEDOR);
                }}
              >
                <i className="bi bi-hdd-stack large-icon"></i>
                <span>Máquinas</span>
              </button>
            ) : (
              <>
                {dataUser?.key === "COLABORADOR" ?
                  null
                  :
                  <button
                    className={
                      location.pathname === links.DASHBOARD_CLIENTES ? "active" : ""
                    }
                    type="button"
                    onClick={() => {
                      navigate(links.DASHBOARD_CLIENTES);
                    }}
                  >
                    <i className="bi bi-people large-icon"></i>
                    <span>Clientes</span>
                  </button>
                }
              </>
            )}
            {dataUser?.tipo === "CHUVEIRO" ? (
              <button
                className={
                  location.pathname === links.LISTA_COLABORADORES ? "active" : ""
                }
                type="button"
                onClick={() => {
                  navigate(links.LISTA_COLABORADORES);
                }}
              >
                <i className="bi bi-people large-icon"></i>
                <span>Colaboradores</span>
              </button>
            ) : (
              ""
            )}
            {dataUser?.key === "ADMIN" ? (
              <button
                className={
                  location.pathname === links.LISTA_MAQUINAS ? "active" : ""
                }
                type="button"
                onClick={() => {
                  navigate(links.LISTA_MAQUINAS);
                }}
              >
                <i className="bi bi-hdd-stack large-icon"></i>
                <span>Máquinas</span>
              </button>
            ) : (
              ""
            )}
            {dataUser?.key === "ADMIN" ? (
              <button
                className={
                  location.pathname === links.MENSALIDADES_ADM_LIST
                    ? "active"
                    : ""
                }
                type="button"
                onClick={() => {
                  navigate(links.MENSALIDADES_ADM_LIST);
                }}
              >
                <i className="bi bi-qr-code large-icon"></i>
                <span>Mensalidades</span>
              </button>
            ) : (
              ""
            )}
            {dataUser?.key === "CLIENT" ? (
              <button
                className={
                  location.pathname === links.NEW_PASSWORD ? "active" : ""
                }
                type="button"
                onClick={() => {
                  navigate(links.NEW_PASSWORD);
                }}
              >
                <i className="bi bi-key large-icon"></i>
                <span>Trocar Senha</span>
              </button>
            ) : (
              ""
            )}
            {dataUser?.key === "CLIENT" ? (
              <button
                className={
                  location.pathname === links.CLIENTE_PAGAMENTOS ? "active" : ""
                }
                type="button"
                onClick={() => {
                  navigate(links.CLIENTE_PAGAMENTOS);
                }}
              >
                <i className="bi bi-credit-card-2-front large-icon"></i>
                <span>Pagamentos</span>
              </button>
            ) : (
              ""
            )}
            {dataUser?.key === "CLIENT" ? (
              <button
                className={
                  location.pathname === links.CLIENTE_MENSALIDADES
                    ? "active"
                    : ""
                }
                type="button"
                onClick={() => {
                  navigate(links.CLIENTE_MENSALIDADES);
                }}
              >
                <i className="bi bi-qr-code large-icon"></i>
                <span style={{ flexWrap: "wrap" }}>Mensalidades</span>
              </button>
            ) : (
              ""
            )}
            <button
              type="button"
              onClick={() => {
                navigate(
                  dataUser?.key === "CLIENT" ? links.SIGNIN : dataUser?.key === "COLABORADOR" ? links.COLABORADOR_SIGNIN : links.ADMIN_SIGNIN
                );
                setDataUser(null);
              }}
            >
              <i className="bi bi-escape large-icon"></i>
              <span>Sair</span>
            </button>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;
